import type {
  AgentName,
  NationalAgent,
  NationalAgentType,
} from 'services/agent/types';

export const createEmptyNationalAgent = (
  agentType: NationalAgentType,
  suggestion?: string,
): NationalAgent => {
  const suggestedNameVariant: AgentName[] | undefined = suggestion
    ? [{name: suggestion}]
    : undefined;

  return {agentType, nameVariants: suggestedNameVariant} as NationalAgent;
};
